import api from '../middleware/api';
import rootReducer from '../reducers';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native
import thunk from 'redux-thunk';
import { applyMiddleware, createStore, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { routerMiddleware } from 'react-router-redux';

const persistConfig = {
	blacklist: ['projects'],
	key: 'root',
	storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default (history) => {
	let store = createStore(persistedReducer, compose(applyMiddleware(thunk, api, routerMiddleware(history))));
	let persistor = persistStore(store);
	return { store, persistor };
};



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js